export default "__VITE_ASSET__B$VBAWIE__"